import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConsumptionExceptionsComponent } from './consumption-exceptions.component';

const routes: Routes = [
  {
    path: '',
    component: ConsumptionExceptionsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ConsumptionExceptionsRoutingModule {}
